import { Pagination, PostsOrPages, SettingsResponse, Tags } from "@tryghost/content-api";
import { getGhostPosts, getGhostSettings, getGhostTags } from "../../../api/ghost";
import { BlogTagHeader } from "../../../components/BlogTagHeader";
import { FAKE_ALL_ARTICLES_TAG } from "../../../components/BlogTagsDisplay";
import { BlogGenericPageLayout } from "../../../pagelayouts/blog/generic";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

const BlogPages = ({ ...rest }: { postOrPages: PostsOrPages; tags: Tags; pagination: Pagination; settings: SettingsResponse }) => (
    <BlogGenericPageLayout
        headerComponent={<BlogTagHeader tag={FAKE_ALL_ARTICLES_TAG} />}
        title={`A Blog on Authory — A Portfolio Builder & Content Backup Tool | Page ${rest.pagination.page}`}
        description={rest.settings.meta_description || undefined}
        {...rest}
        canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.BLOG}/page/${rest.pagination.page}`}
    />
);

export async function getStaticPaths() {
    const postOrPages = await getGhostPosts();
    const { pagination } = postOrPages.meta;

    let paths: { params: { page: string } }[] = [];

    for (let pageIndex = 1; pageIndex <= pagination.pages; pageIndex++) {
        paths.push({ params: { page: pageIndex.toString() } });
    }

    return { paths, fallback: "blocking" };
}

export async function getStaticProps(ctx: any) {
    try {
        const page = ctx.params.page as string;

        const postOrPages = await getGhostPosts(parseInt(page));
        const { pagination } = postOrPages.meta;
        const tags = await getGhostTags();
        const settings = await getGhostSettings();

        return {
            props: {
                postOrPages,
                tags,
                pagination,
                settings
            }
        };
    } catch {
        if (ctx.res) {
            ctx.res.statusCode = 404;
            ctx.res.end();
        }

        return { props: { statusCode: 404 } };
    }
}

export default BlogPages;
